/* eslint-disable angular/file-name */
angular.module('zc.core')
  .component('zcSyncContractInfoButton', {
    templateUrl: '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html',
    bindings: {
      source: '=',
      syncTargetName: '@',
    },
    controller: SyncContractInfoButtonController,
    controllerAs: 'vm',
  });

SyncContractInfoButtonController.$inject = ['$translate'];
function SyncContractInfoButtonController($translate) {
  const SYNC_TARGET_NAME = $translate.instant('sharedModules.core.components.syncContractInfoButton.kaisha_jouhou');

  // contractInfoField: billingInfoField
  const FIELDS_TO_BE_SYNCED = {
    company_name: 'billing_company_name',
    address: 'billing_address',
    postal_code: 'billing_postal_code',
    phone_number: 'billing_phone_number',
  };

  const ALIAS_FIELDS = {
    // agency's title field equals company_name
    company_name: 'title',
  };

  const vm = this;

  // Loop the above FIELDS_TO_BE_SYNCED and assign
  // billingInfoField's value to contractInfoField
  function syncContractInfoWithBillingInfo() {
    _.forEach(FIELDS_TO_BE_SYNCED, function(billingInfoField, contractInfoField) {

      if(!isSourceHasField(contractInfoField)) {
        const aliasField = _.get(ALIAS_FIELDS, contractInfoField);
        if(!isSourceHasField(aliasField)) {
          console.error(`Source missing a field: ${contractInfoField}.`);
          return;
        }

        contractInfoField = aliasField;
      }

      vm.source[billingInfoField] = vm.source[contractInfoField];
    });
  }

  function isSourceHasField(field) {
    return _.has(vm.source, field);
  }

  vm.$onInit = () => {
    vm.syncContractInfoWithBillingInfo = syncContractInfoWithBillingInfo;

    if(!this.syncTargetName) {
      vm.syncTargetName = SYNC_TARGET_NAME;
    }
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/sync_contract_info_button/sync_contract_info_button.js